import React, { useState } from 'react';
import useCdn from '../../../../hooks/useCdn';
import useToggle from '../../../../hooks/useToggle';
import { formatImage } from '../../../../utils/image';
import { HighlightBox } from '../../../../styled/HighlightBox/wrappers';
import Suspense from '../../../../components-legacy/Suspense';
import ImageBox from '../../../../styled/ImageBox';
import Panel from '../../../../styled/Panel';
import useSelectedOption from './useSelectedOption';
import Loader from '../../../../styled/Loader';

import {
  Label,
  Value,
  TextContainer,
  Action,
  Image,
  ValueButton,
  MediaContainer,
} from '../../../../styled/ValueButton/wrappers';

const OptionItemSelector = React.lazy(() => import('./OptionItemSelector'));

interface IOption {
  description?: string;
  items: IConfigurationItem[];
  label: string;
  type: ConfigurationType;
}

const Option = ({ description, items, label, type }: IOption) => {
  const getCdnUrl = useCdn('/images/products/');
  const [show, toggleShow, , unsetShow] = useToggle(false);
  const selectedItem = useSelectedOption(type, items);
  const altText = `${label} - ${selectedItem?.name}`;
  const [initialSelectedGroup, setInitialSelectedGroup] = useState<string | undefined>(undefined);

  const persistInitialSelectedGroup = (group: string) => {
    setInitialSelectedGroup(group);
  };

  return (
    <>
      <HighlightBox>
        <ValueButton onClick={toggleShow}>
          {selectedItem?.media?.[0]?.url && (
            <MediaContainer>
              <ImageBox width="56px" height="56px">
                <picture>
                  <source
                    type="image/webp"
                    srcSet={formatImage(getCdnUrl(selectedItem?.media?.[0]?.url), {
                      width: 56,
                      height: 56,
                      cdn: true,
                      output: 'webp',
                    })}
                  />
                  <Image
                    src={formatImage(getCdnUrl(selectedItem?.media?.[0]?.url), {
                      width: 56,
                      height: 56,
                      cdn: true,
                    })}
                    width="56"
                    height="56"
                    loading="lazy"
                    className="round"
                    alt={altText}
                  />
                </picture>
              </ImageBox>
            </MediaContainer>
          )}
          <TextContainer>
            <Label>{label}</Label>
            <Value>{selectedItem?.name}</Value>
          </TextContainer>
          <Action>Ändra</Action>
        </ValueButton>
      </HighlightBox>
      {show && (
        <Panel
          className="no-body-padding"
          noScrollLock
          onClose={unsetShow}
          title={`Välj ${label?.toLocaleLowerCase() || type}`}>
          <Suspense fallback={<Loader />}>
            <OptionItemSelector
              initialSelectedGroup={initialSelectedGroup}
              persistInitialSelectedGroup={persistInitialSelectedGroup}
              description={description}
              items={items}
              onDone={unsetShow}
              type={type}
            />
          </Suspense>
        </Panel>
      )}
    </>
  );
};

export default Option;
